<template>
  <div id="colores">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="COLORES DE PROUDCTO" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevoColor"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-color
                  :color="color"
                  ref="dialogColor"
                  @onColorAdded="onColorAdded"
                  @onColorUpdated="onColorUpdated"
                ></form-color>
              </div>

              <v-layout row wrap>
                <v-flex lg8 sm12 xs12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="colores"
                          hide-actions
                          class="elevation-0 table-styling"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-icon color="primary">album</v-icon>
                            </td>
                            <td>CO-{{ zeroFill(props.item.colorId, 3) }}</td>
                            <td>{{ props.item.nombre }}</td>
                            <td class="text-lg-center">
                              <v-icon :color="props.item.codigoHtml" medium
                                >widgets</v-icon
                              >
                            </td>
                            <td class="text-lg-center">
                              {{ props.item.codigoRgb }}
                            </td>
                            <td class="text-lg-center">
                              {{ props.item.codigoHtml }}
                            </td>
                            <td class="text-xs-right">
                              <v-btn
                                flat
                                icon
                                color="grey"
                                @click="getColor(props.item.colorId)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                icon
                                color="grey"
                                :loading="$store.state.loadingDelete.show"
                                @click="deleteColor(props.item.colorId)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                        </v-data-table>
                      </template>
                      <v-divider></v-divider>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formColor from "./FormColor";
import colorService from "@/services/colorService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    formColor,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "CLAVE",
          align: "left",
          value: "colorId",
          visibility: "hidden-lg-only",
        },
        { text: "NOMBRE", align: "center", value: "nombre" },
        { text: "REFERENCIA", align: "center", sortable: false },
        { text: "CÓDIGO RGB", align: "center", value: "codigoRgb" },
        { text: "CÓDIGO HTML", align: "center", value: "codigoHtml" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      colores: [],
      color: {
        colorId: 0,
        nombre: "",
        codigoRgb: "",
        codigoHtml: "",
      },
    };
  },
  mounted() {
    this.getColores();
  },
  methods: {
    abrirDialogNuevoColor() {
      this.$store.state.tituloForm = "AGREGAR COLOR";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogColor.resetForm();
      this.$refs.dialogColor.openDialog();
    },
    getColores() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      colorService
        .getAll()
        .then((result) => {
          self.colores = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getColor(colorId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      colorService
        .get(colorId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR COLOR PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";

          self.$refs.dialogColor.resetForm();
          self.color = result;
          self.$refs.dialogColor.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteColor(id) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR COLOR PRODUCTO",
          "¿Estás seguro de eliminar el color seleccionado?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            colorService
              .delete(id)
              .then((result) => {
                var i = this.colores.findIndex((obj) => obj.colorId == id);
                self.colores.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Color de producto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onColorAdded(color) {
      this.colores.push(color);
    },
    onColorUpdated(color) {
      var i = this.colores.findIndex((obj) => obj.colorId == color.colorId);
      this.colores.splice(i, 1, color);
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
